module.exports = __webpack_public_path__ + "static/media/light_4650.png.d06e978d.webp";